<template>
  <div class="word_upload">
    
    <!--   action="/api/file/addFileByOtherId" -->
    <el-upload
      :data="Id !='' && baFileMenuId != undefined?edidDate:uploadData"
      :headers="uploadHeaders"

:action="Id !='' && baFileMenuId != undefined ?'/api/file/editFileByOtherId':'/api/file/addFileByOtherId'"
      
      multiple
      :show-file-list="false"
      :on-success="handsuccess"
      :on-progress="uploadProgress"
      :on-error="uploadFileError"
      :before-upload="beforeUpload"
    >
      <el-button
        type="text"
        :icon="[
          Id != '' && baFileMenuId != undefined
            ? 'el-icon-refresh'
            : 'el-icon-upload'
        ]"
      >
        {{ Id != "" && baFileMenuId != undefined ? "替换" : "上传" }}</el-button
      >
     
    </el-upload>
    
  </div>
</template>

<script>
import Cookies from "js-cookie";
import * as api from "@/api/text/text";
export default {
  name: "wordUpload",
  data() {
    return {
      progressFlag: false,
      uploadPercent: 0,
      uploadNum: 0,
      filesLength: 0,
    };
  },
  computed: {
    uploadHeaders() {
      return {
        "Blade-Auth": "bearer " + Cookies.get("saber-access-token")
      };
    },
    uploadData() {
      return {
        baFileMenuId: this.Id,
        fileOtherId: this.bankid,
      //  id:this.fileMenuIsMust
      };
    },
    edidDate(){
      return {
        id:this.Id,
        fileOtherId:this.bankid,
        baFileMenuId:this.baFileMenuId

      }
    }

  },
  created() {
    // console.log(this.PageId,this.baFileMenuId,this.Id)
  },
  props: ["baFileMenuId", "PageId", "Id", "fileMenuIsMust", "bankid"],
  methods: {
    beforeUpload(files){
      
      this.filesLength=this.filesLength+1
      
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    uploadProgress(event, file, fileList) {
      let max = Math.max.apply(
          Math,
          fileList.map(function (value) {
            return value.size;
          })
        );
        if (file.size == max) {
          
          this.uploadPercent = Math.floor(event.percent);
          if (this.uploadPercent == 100) {
            this.uploadPercent = 99;
          }
          this.$emit("uploadProgress", this.uploadPercent, true);
        }
    },
    handsuccess(file, fileList) {
      let that=this
      this.uploadNum = this.uploadNum + 1;
      if (that.uploadNum == that.filesLength) {
                   
              that.uploadNum = 0;
              
              that.filesLength=0
              that.$emit("update", true);
      }
    },
    //上传失败
	  uploadFileError(err, file, fileList){
       this.$emit("uploadProgress", 0, false);
	     this.$message.error("上传失败！")
	  },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    }

    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // }
  }
};
</script>

<style lang="scss" scoped>
.progress_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  opacity: .3;
  background: #000;
  z-index: 2000;
  .progress_modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
